<ng-container *ngIf="applications$ | async as applications">
	<div class="search-bar">
		<dx-tag-box id="tagBoxContainer" [items]="applications" [searchEnabled]="true" placeholder="Search..."
			displayExpr="displayName" valueExpr="id" [value]="selectedApps" itemTemplate="customItem"
			tagTemplate="customTag" (onValueChanged)="filterChanged($event)">
			<div *dxTemplate="let application of 'customItem'">
				<div class="custom-item">
					<img [src]="getUrl('/application-logos/'+application.imageRef)" />
					<div class="product-name">
						{{application.displayName}}
					</div>
				</div>
			</div>
			<div *dxTemplate="let application of 'customTag'">
				<div class="custom-item tag">
					<img [src]="getUrl('/application-logos/'+application.imageRef)" />
					<div class="product-name">
						{{application.displayName}}
					</div>
					<div class="dx-tag-remove-button"></div>
				</div>
			</div>
		</dx-tag-box>
		<i class="far fa-search search-icon"></i>
		<div style="margin-left: 20px" *ngIf="canManageApplicationLinkAdministrationSubject | async">
			<button  class="btn btn-primary btn-sm" (click)="manageLinkInformation()">[Admin]</button>
		</div>
	</div>

	<dx-tooltip target="#tagBoxContainer" position="bottom" [hideEvent]="{ name: 'mouseout', delay: 2000 }"
		[(visible)]="this.tagLimit">
		<div *dxTemplate="let data of 'content'">
			<h6>Limit reached</h6>
		</div>
	</dx-tooltip>
	<br>
	<div class="container-new">
		<div class="item-new">
			<fieldset
				style="border: 4px dashed white; background-color: rgba(255,255,255,0.35); padding-left: 20px; padding-bottom: 10px; margin-bottom: 5px;">
				<legend>Accounting</legend>
				<div class="quick row">
					<div class="card iconhover" *ngFor="let app of filterAccounting(applications)"
						(click)="addToFilter(app.id)" [class.selected]="selected(app.id)">
						<img title="{{app.displayName}}" style="width:auto; height:74px"
							[src]="getUrl('/application-logos/'+app.imageRef)" />
					</div>
				</div>
			</fieldset>
		</div>
		<div class="item-new">
			<fieldset
				style="border: 4px dashed white; background-color: rgba(255,255,255,0.35); padding-left: 20px; padding-bottom: 10px; margin-bottom: 5px;">
				<legend>Cloud Marketplace</legend>
				<div class="quick row">
					<div class="card iconhover" *ngFor="let app of filterCSP(applications)"
						(click)="addToFilter(app.id)" [class.selected]="selected(app.id)">
						<img title="{{app.displayName}}" style="width:auto; height:74px"
							[src]="getUrl('/application-logos/'+app.imageRef)" />
					</div>
				</div>
			</fieldset>
		</div>

		<div class="item-new">
			<fieldset
				style="border: 4px dashed white; background-color: rgba(255,255,255,0.35); padding-left: 20px; padding-bottom: 10px; margin-bottom: 5px;">
				<legend>PSA</legend>
				<div class="quick row">
					<div class="card iconhover" *ngFor="let app of filterPSA(applications)"
						(click)="addToFilter(app.id)" [class.selected]="selected(app.id)">
						<img title="{{app.displayName}}" style="width:auto; height:74px"
							[src]="getUrl('/application-logos/'+app.imageRef)" />
					</div>
				</div>
			</fieldset>
		</div>
		<div class="item-new">
			<fieldset
				style="border: 4px dashed white; background-color: rgba(255,255,255,0.35); padding-left: 20px; padding-bottom: 10px; margin-bottom: 5px;">
				<legend>Other</legend>
				<div class="quick row">
					<div class="card iconhover" *ngFor="let app of filterOther(applications)"
						(click)="addToFilter(app.id)" [class.selected]="selected(app.id)">
						<img title="{{app.displayName}}" style="width:auto; height:74px"
							[src]="getUrl('/application-logos/'+app.imageRef)" />
					</div>
				</div>
			</fieldset>
		</div>
	</div>
</ng-container>

<!-- showScrollbar="onHover" [bounceEnabled]="pullDown" reachBottomText="Updating..."
	(onPullDown)="onPullDown($event)" (onReachBottom)="addContent($event)" -->

<app-shell-tile-information [linkInformation]="selectedLinkInformation" #tileInformation></app-shell-tile-information>

<dx-scroll-view #scrollView class="scrollView">
	<div class="cards-container" *ngIf="items else noItems">
		<div class="flex-container card clickable-card" *ngFor="let item of items | sort:'sortingIndex';" (click)="openTileInformation($event, item)">
			<ng-container *ngIf="!(item.fromAppHeaderImageRef) && !(item.toAppHeaderImageRef)">
				<div class="header">Placeholder</div>
			</ng-container>
			<ng-container *ngIf="item.fromAppHeaderImageRef || item.toAppHeaderImageRef">
				<div class="header" [ngStyle]="{'background-color': setHeaderColor(item)}"><img class="appTile"
					[src]="getUrl(getProperImageRef(item))" /></div>
			</ng-container>


			<div class="header-padding"></div>
			<div class="applicationlink-icon"><img style="width: 50px; height: 50px;"
					src="https://i.imgur.com/rkwEj1G.png"></div>
			<div class="integrationtitle-flexbox">
				<!-- <div class="integrationtitle">{{item.toDName}}</div> -->
				<ng-container *ngIf="item.fromAppHeaderImageRef || item.toAppHeaderImageRef">
					<div class="integrationtitle">{{getIntegrationTitleName(item)}}</div>
				</ng-container>
				<ng-container *ngIf="!(item.fromAppHeaderImageRef) && !(item.toAppHeaderImageRef)">
					<div class="header">Placeholder</div>
				</ng-container>

				<!-- <ng-container *ngIf="item.toAppHeaderImageRef && item.fromAppHeaderImageRef">
					<div class="integrationtitle">{{item.fromDName}}</div>
				</ng-container>

				<ng-container *ngIf="item.toAppHeaderImageRef && !item.fromAppHeaderImageRef">
					<div class="integrationtitle">{{item.fromDName}}</div>
				</ng-container>

				<ng-container *ngIf="item.fromAppHeaderImageRef && !item.toAppHeaderImageRef">
					<div class="integrationtitle">{{item.toDName}}</div>
				</ng-container>
	 -->
				<div class="integrationsubtitle">{{item.shortDescription}}</div>
			</div>
			<!-- <div class="applicationlink-add-link-button">
				<div><button class="custom-button">Add link</button></div>
			</div> -->
		</div>
		<!-- <div class="custom-card card clickable-card" *ngFor="let item of items;" (click)="addApplication($event, item.id)">
			<h5 class="card-title">{{ item.displayName }}</h5>
			<div class="row">
				<div class="card-left">
					<div class="card-img">
						<img [src]="getUrl('/application-logos/'+item.fromImageRef)" />
					</div>
					<img class="card-link" [src]="getUrl('/application-logos/applicationlinklink.png')" />
					<div class="card-img">
						<img [src]="getUrl('/application-logos/'+item.toImageRef)" />
					</div>
				</div>
				<div class="card-divider"></div>
				<div class="card-right">
					<div class="card-description" [innerHTML]="item.shortDescription"></div>
					<button class="btn card-button btn-success">Add Link</button>
				</div>
			</div>
		</div> -->
		<div class="card custom-card message empty-filter" *ngIf="this.items.length === 0">
			<h4 class="title">Sorry!</h4>
			<i class="far fa-frown fa-8x icon"></i>
			<div class="divider"></div>
			<p class="description">We couldn't find integrations with this filter!</p>
		</div>
	</div>
	<ng-template #noItems>
		<div class="card custom-card message empty-filter">
			<h4 class="title">Loading</h4>
			<i class="far fa-clock fa-8x icon"></i>
			<div class="divider"></div>
			<p class="description">Retrieving integrations...</p>
		</div>
	</ng-template>
</dx-scroll-view>

<app-shell-admin-marketplace-management #adminMenu></app-shell-admin-marketplace-management>
